import CircleIcon from "@mui/icons-material/Circle";
import {
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  Stack,
  FormLabel,
} from "@mui/material";
import { useStore } from "@tanstack/react-form";

import { withForm } from "components/Forms/AppForm";

import { ppFilterDefaultValues } from "../../context/ppFilterDefaultValues";

import type React from "react";

const PpStatusOptions = withForm({
  defaultValues: ppFilterDefaultValues,
  render: function Render({ form }) {
    const archived = useStore(form.store, (state) => state.values.archived);

    // Determine current selection based on archived value
    const currentValue = archived ? "archived" : "approved";

    const handleStatusChange = (
      _e: React.MouseEvent,
      newValue: string | null,
    ) => {
      if (!newValue) return;
      form.setFieldValue("archived", newValue === "archived");
    };

    return (
      <Stack gap={0.5} marginTop={3}>
        <FormLabel>Status</FormLabel>
        <ToggleButtonGroup
          value={currentValue}
          orientation="vertical"
          size="small"
          fullWidth
          exclusive
          sx={{
            ".MuiToggleButtonGroup-grouped": {
              marginY: "5px",
              borderRadius: "4px",
              "&.Mui-selected": {
                background: "#0b2241",
                color: "white",
                "&:hover": {
                  background: "#0b2241",
                },
              },
            },
          }}
          onChange={handleStatusChange}
        >
          <StatusButton
            value="approved"
            label="Approved"
            color="var(--bs-green)"
          />
          <StatusButton
            value="archived"
            label="Archived"
            color="var(--bs-orange)"
          />
        </ToggleButtonGroup>
      </Stack>
    );
  },
});

export default PpStatusOptions;

interface StatusButtonProps {
  color: string;
  label: string;
  value: string;
}

const StatusButton = ({ color, label, value }: StatusButtonProps) => {
  return (
    <ToggleButton value={value} id={`status-btn-${value}`}>
      <CircleIcon fontSize="small" htmlColor={color} />
      <Typography
        fontSize="14px"
        fontFamily="var(--bs-btn-font-family)"
        flex="1"
        marginLeft={-1}
      >
        {label}
      </Typography>
    </ToggleButton>
  );
};
